<template>
    <div style="background-color: #FFF">
        <a target="_blank" v-bind:href="`/preview/${designId}`">
            <div
                class="easel small"
                v-bind:class="`type_${selectedCategory}_${selectedSide}`">
                <div
                    class="easel-inner"
                    v-bind:style="{ backgroundImage: 'url(' + selectedDesignGarmentColour + ')' }">
                    <canvas v-bind:id="canvasId"></canvas>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import fabric from 'fabric';
import axios from '../../axios';

export default {
    name: 'PreviewDesign',
    props: [
        'designId',
        'itemNo',
    ],
    computed: {
        basket() {
            return this.$store.getters.basketItems;
        },
        garments() {
            const gs = [];
            const g = {};
            for (let i = 0; i < this.basket.length; i += 1) {
                g.product_code = this.basket[i].product_code;
                g.colour_code = this.basket[i].colour_code;
                g.name = this.basket[i].name;
                gs.push(g);
            }
            return gs;
        },
        selectedDesignGarmentColour() {
            let sdgc = false;
            if (this.garments[0]) {
                let side = '';
                if (this.selectedSide === 'Front') {
                    side = 'FRONT';
                } else if (this.selectedSide === 'Back') {
                    side = 'BACK';
                } else if (this.selectedSide === 'Left') {
                    side = 'LEFT';
                } else if (this.selectedSide === 'Right') {
                    side = 'RIGHT';
                }
                let productCode = '';
                let colourCode = '';
                if (this.backgroundChosen === false) {
                    productCode = this.garments[this.chosenGarment].product_code;
                    colourCode = this.garments[this.chosenGarment].colour_code;
                } else {
                    productCode = this.backgroundChosen.productCode;
                    colourCode = this.backgroundChosen.colourCode;
                }
                sdgc = `https://runsmart-dropship.s3.eu-west-2.amazonaws.com/garments/pencarrie_images/${productCode}+${colourCode}+${side}.jpg`;
            }
            return sdgc;
        },
        canvasId() {
            let canvasId = 'c';
            if (this.itemNo === 0) canvasId = 'd';
            if (this.itemNo === 1) canvasId = 'e';
            if (this.itemNo === 2) canvasId = 'f';
            if (this.itemNo === 3) canvasId = 'g';
            if (this.itemNo === 4) canvasId = 'h';
            if (this.itemNo === 5) canvasId = 'i';
            if (this.itemNo === 6) canvasId = 'j';
            if (this.itemNo === 7) canvasId = 'k';
            if (this.itemNo === 8) canvasId = 'l';
            if (this.itemNo === 9) canvasId = 'm';
            return canvasId;
        },
    },
    data() {
        return {
            back: {},
            backgroundChosen: false,
            canvas: {},
            chosenGarment: 0,
            front: {},
            left: {},
            right: {},
            selectedCategory: 1,
            selectedSide: 'Front',
        };
    },
    methods: {
        getDesign() {
            const postData = {};
            postData.id = this.designId;
            axios.post('/Designs/getPreview.json', postData)
            .then((response) => {
                for (let i = 0; i < response.data.designGroup.length; i += 1) {
                    if (response.data.designGroup[i].side === 'Front') {
                        this.front = response.data.designGroup[i];
                    }
                    if (response.data.designGroup[i].side === 'Back') {
                        this.back = response.data.designGroup[i];
                    }
                    if (response.data.designGroup[i].side === 'Left') {
                        this.left = response.data.designGroup[i];
                    }
                    if (response.data.designGroup[i].side === 'Right') {
                        this.right = response.data.designGroup[i];
                    }
                }
                this.renderPreview();
            });
        },
        renderPreview() {
            const design = this.front;
            const json = design.canvas_string;
            this.canvas = new fabric.fabric.Canvas(this.canvasId);
            this.canvas.setZoom(0.2);
            this.canvas.setWidth(650 * this.canvas.getZoom());
            this.canvas.setHeight(800 * this.canvas.getZoom());
            this.canvas.loadFromJSON(
                json,
                this.canvas.renderAll.bind(this.canvas),
            );
        },
    },
    mounted() {
        this.getDesign();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Order/PreviewSingle.vue